import React, { Component } from "react";
import InstructionBox from "../InstructionBox";
import Button from "../../design-system/Button/Button";

interface propType {
  toggleTotp: () => void;
  from?: string;
  breakPoints: any;
  theme: string;
}

interface stateType {
  img1Open: boolean;
  img2Open: boolean;
  img3Open: boolean;
  isJourneyOpen: boolean;
  isManualApproveOpen: boolean;
  images: string[];
  currentImageIndex: number;
  breakPoints: any;
}

export class ApproveSTotpTransfer extends Component<propType, stateType> {
  interval: NodeJS.Timeout | null = null;

  constructor(props: propType) {
    super(props);
    this.state = {
      img1Open: false,
      img2Open: false,
      img3Open: false,
      isJourneyOpen: false,
      isManualApproveOpen: false,
      images: [
        `${this.props.theme}-step1.svg`,
        `${this.props.theme}-step2.svg`,
        `${this.props.theme}-step3.svg`,
      ],
      currentImageIndex: 0,
      breakPoints: null,
    };
    this.navigateTotp = this.navigateTotp.bind(this);
  }

  componentDidMount() {
    this.interval = setInterval(this.nextImage, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval!);
  }

  nextImage = () => {
    this.setState((prevState: stateType) => ({
      ...prevState,
      currentImageIndex:
        (prevState.currentImageIndex + 1) % this.state.images.length,
    }));
  };

  navigateTotp = () => {
    this.props.toggleTotp();
  };

  render() {
    const { lg } = this.props.breakPoints;
    console.log("breakpoints", this.props.breakPoints);

    return (
      <div className="flex flex-col items-start gap-5 justify-around w-100 xs:px-10 xs:py-5  sm:px-10 sm:py-5 lg:px-10 lg:py-5 xl:px-20 xl:py-10 ">
        {!lg ? (
          <div className="flex flex-row w-100 gap-6 justify-between z-10 space-x-4">
            <InstructionBox
              id="1"
              img={this.state.images[this.state.currentImageIndex]}
              className="animate-slideRight1 initial-hidden"
            />
          </div>
        ) : (
          <div className="flex flex-row w-100 gap-6 justify-between z-10 space-x-4">
            <InstructionBox
              id="1"
              img={`${this.props.theme}-step1.svg`}
              className="animate-slideRight1 initial-hidden"
            />

            <InstructionBox
              id="2"
              img={`${this.props.theme}-step2.svg`}
              className="animate-slideRight2 initial-hidden"
            />

            <InstructionBox
              id="3"
              img={`${this.props.theme}-step3.svg`}
              className="animate-slideRight3 initial-hidden"
            />
          </div>
        )}

        {lg && (
          <div
            className="flex absolute flex-row w-[803px] bottom-[34%] animate-slideUp-d-1 initial-hidden
             z-0"
          >
            <div className="relative flex flex-row left-[225px] items-center">
              <div className="w-[18px] h-[18px] gap-0 bg-gray-50_02 rounded-lg" />
              <div className="border-gray-50_02 border-dashed border-b-2 h-0 w-[36px] mx-[0.5px]" />
              <div
                className="w-[18px] h-[18px] 
              gap-0 bg-gray-50_02 rounded-lg"
              />
            </div>

            <div className="relative flex flex-row left-[434px] items-center">
              <div
                className="w-[18px] h-[18px] 
              gap-0  
              bg-gray-50_02 rounded-lg"
              />
              <div className="border-gray-50_02 border-dashed border-b-2 h-0 w-[36px] mx-[0.5px]" />
              <div
                className="w-[18px] h-[18px] 
              gap-0 bg-gray-50_02 rounded-lg"
              />
            </div>
          </div>
        )}

        {lg ? (
          <div className=" w-[803px] h-[94px] ">
            <div
              className=" border-lightGray bg-gray-100_01 w-[803px] h-[94px] gap-0 border 
              rounded-[12px] border-[0px_0px] left-[71px] top-[604px]
             flex flex-row py-[26px] px-[16px] justify-between items-center animate-slideUp-d-1 initial-hidden"
            >
              <div className="flex flex-col">
                <p className="text-base font-medium leading-6 text-left">
                  Haven't received any notifications?
                </p>

                <p className="text-[13px] font-medium leading-6 text-left">
                  Here’s how to approve the transaction manually
                </p>
              </div>

              <Button variant="primary" onClick={this.navigateTotp}>
                Approve Manually
              </Button>
            </div>
          </div>
        ) : (
          <div className="w-full flex justify-center items-center">
            <Button variant="primary" onClick={this.navigateTotp}>
              Approve Manually
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default ApproveSTotpTransfer;
